export default theme => ({
  datagrid: {
    // fix buggy position of a header cell's sort arrow
    '& .MuiDataGrid-colCellTitleContainer .MuiDataGrid-iconButtonContainer div:first-child': {
      display: 'block',
      position: 'absolute',
      top: '50%',
      marginTop: -12
    },
    '& .MuiDataGrid-toolbar': {
      paddingTop: theme.spacing(1),
      paddingLeft: theme.spacing(1.5),
      '& .MuiButton-root': {
        marginRight: theme.spacing(1)
      }
    }
  }
});
